// extracted by mini-css-extract-plugin
export default {"root":"spacer_root__SxB17"};